<template>
  <ul 
    v-if="list.length"
    v-rellax="{ list, rellaxSpeed }"
    class="categories-list">
    <li 
      v-for="(category, index) of list"
      :key="index"
      v-lazy-container="{ selector: 'img' }"
      class="category-list__home_hover">
      <router-link :to="{ name: `${lang}.single-category`, params: { slug: category.fields.slug } }">
        <img
          v-if="typeof category.fields.imageSet !== 'undefined'"
          :data-src="category.fields.imageSet.fields.file.url"
          :data-loading="lazyLoading"
          :alt="category.fields.imageSet.fields.description"
          :width="category.fields.imageSet.fields.file.details.image.width"
          :height="category.fields.imageSet.fields.file.details.image.height">
        <p>{{ category.fields.title }}</p>
        <span>{{ $tc('common.references', $_getProductsCount(category.fields.slug)) }}</span>
      </router-link>
    </li>
  </ul>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Rellax from 'rellax'
export default {
  name: 'CategoriesList',
  data: () => ({
    lazyLoading: require('@/assets/lazy/home-category.png'),
    loading: true,
    rellaxRef: undefined
  }),
  props: {
    list: {
      type: Array,
      required: true
    },
    rellaxSpeed: {
      type: Number,
      default: undefined
    }
  },
  computed: {
    ...mapGetters('contentful', [
      'products'
    ]),
    ...mapGetters([
      'lang'
    ])
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('contentful', [
      'loadProducts'
    ]),
    $_getProductsCount (currentSlug) {
      if (this.loading) return ''
      return this.products.filter((product) => (typeof product.fields.category !== 'undefined' && product.fields.category.fields.slug === currentSlug)).length
    },
    async loadData () {
      this.loading = true
      try {
        await Promise.all([this.loadProducts()])
        this.loading = false
      } catch (e) {
        // TODO sentry
      }
    }
  },
  directives: {
    'rellax': {
      inserted (el, binding, vnode) {
        if (typeof binding.value.rellaxSpeed !== 'undefined'){
          const rellaxRef = new Rellax(el, {
            speed: binding.value.rellaxSpeed,
            center: false,
            wrapper: null,
            round: true,
            vertical: true,
            horizontal: false
          })
          vnode.context.$data.rellax = rellaxRef
        }
      },
      componentUpdated(el, binding, vnode){
        if (typeof binding.value.rellaxSpeed !== 'undefined') vnode.context.$data.rellax.refresh()
      },
      unbind (el, binding, vnode) {
        if (typeof binding.value.rellaxSpeed !== 'undefined') vnode.context.$data.rellax.destroy()
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./list.scss";
</style>
